import { call, put, takeLatest } from 'redux-saga/effects';
import { TActionEventTeamDetailsRequested, ActionTypes, actions } from './modules';
import { commonApiServiceAsync } from '../services/commonApiService';

function* viewEventTeamDetails(action: TActionEventTeamDetailsRequested): any {
  const { team, namespace } = action.payload;

  try {
    const results = yield call(commonApiServiceAsync.viewEventTeamDetails, { team, namespace });

    yield put(actions.setViewEventTeamDetailsSucceeded({ results: results.viewEventTeamDetailsApi }));
  } catch (e) {
    yield put(
      actions.setViewEventTeamDetailsFailed({
        team,
        namespace,
        error: e.toString()
      })
    );
  }
}

function* watchViewEventTeamDetailsRequested(): any {
  // TODO: should this be a `takeEvery` so if someone hits multiple create buttons it will create each one?
  yield takeLatest(ActionTypes.SET_EVENT_TEAM_DETAILS_REQUESTED, viewEventTeamDetails);
}

export default [watchViewEventTeamDetailsRequested()];
